import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  public dictionaryIsReady$ = new BehaviorSubject<boolean>(false);

  public dictionaryIsReady(): Observable<boolean> {
    return this.dictionaryIsReady$.asObservable();
  }
}
